<template>
  <div class="channelRecord">
    <PageNav :openMenu="openMenu">
      <el-main>
        <div id="page-custoMersmanage" v-if="channelCompareData">
          <!-- 页面头部 -->
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <div class="flex-all">
                <span class="c-normal">撞单详情</span>
                <div
                  class="cursor-pointer"
                  @click="
                    $router.push({
                      path: '/Customersmanage/ChannelChangeRecord',
                    })
                  "
                >
                  <el-icon
                    name="close"
                    style="color: #333; font-size: 20px"
                  ></el-icon>
                </div>
              </div>
            </div>
          </div>
          <!-- 主要内容区域 -->
          <div class="custoMersmanage-container">
            <div
              class="content"
              style="padding: 0 !important; margin: 0 !important"
            >
              <div class="collision-record">
                <div class="collision-content mb20">
                  <div class="collision-content-title">撞单概要</div>
                  <div class="collision-content-box flex flex-wrap">
                    <div class="flex p items-center">
                      <span class="content-title">撞单时间：</span>
                      <span
                        class="content-row"
                        style="font-size: 15px; line-height: 100%"
                        >{{ channelCompareData.conflicts_createtime_str }}</span
                      >
                    </div>
                    <div class="flex p items-center">
                      <span class="content-title">名单信息：</span>
                      <span class="content-row">
                        {{ channelCompareData.from_cnname }}
                        {{ channelCompareData.from_mobile }}
                      </span>
                    </div>
                    <div class="flex p items-center">
                      <span class="content-title">名单撞单结果：</span>
                      <span
                        class="content-row content-row-status"
                        :class="{
                          'content-row-status-success':
                            channelCompareData.conflicts_issuccess == 1,
                          'content-row-status-fail':
                            channelCompareData.conflicts_issuccess == 0,
                        }"
                        >{{ channelCompareData.conflicts_issuccess_name }}</span
                      >
                    </div>
                    <div class="flex p items-center">
                      <span class="content-title">渠道撞单结果：</span>
                      <span
                        class="content-row content-row-status"
                        :class="{
                          'content-row-status-success':
                            channelCompareData.channel_issuccess == 1,
                          'content-row-status-fail':
                            channelCompareData.channel_issuccess == 0,
                        }"
                        >{{ channelCompareData.channel_issuccess_name }}</span
                      >
                    </div>
                    <div class="flex p items-center">
                      <span class="content-title">触发规则：</span>
                      <span class="content-row">
                        {{ channelCompareData.conflicts_rules }}
                      </span>
                    </div>
                    <div class="flex p">
                      <span class="content-title">系统执行动作：</span>
                      <div
                        class="content-row"
                        v-html="channelCompareData.tackleCodesStr || '--'"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="collision-content mb20">
                  <div class="collision-content-title flex items-center">
                    <span class="mr20">撞单路径对比</span>
                    <div class="flex items-center channel-compare">
                      <span class="channel-compare-title">名单进入: </span>
                      <span class="channel-compare-content">
                        <!-- {{ channelCompareData.from_channelstr }} -->
                        {{ channelCompareData.from_school_cnname }}（{{
                          channelCompareData.from_channelstr
                        }}）
                      </span>
                    </div>
                  </div>
                  <div class="collision-content-box">
                    <div class="flex items-center">
                      <div class="compare-channnel-left pb20">
                        <div class="compare-channel-row__title">撞单前</div>
                        <div class="compare-channnel-row">
                          <span>归属:</span>
                          <span>{{
                            channelCompareData.now_school_cnname
                          }}</span>
                        </div>
                        <div class="compare-channnel-row">
                          <span>渠 道:</span>
                          <span>{{ channelCompareData.now_channelstr }}</span>
                        </div>
                        <div class="compare-channnel-row">
                          <span>撞单前名单状态:</span>
                          <span>{{
                            channelCompareData.now_traceStatus_name
                          }}</span>
                        </div>
                        <div class="compare-channnel-row">
                          <span>撞单前负责人:</span>
                          <span>{{ channelCompareData.now_marketer_str }}</span>
                        </div>
                      </div>
                      <span class="compare-channel-arrow">&gt;</span>
                      <div class="compare-channnel-right pb20">
                        <div class="compare-channel-row__title">撞单后</div>
                        <div class="compare-channnel-row">
                          <span>归属:</span>
                          <span>{{
                            channelCompareData.end_school_cnname
                          }}</span>
                        </div>
                        <div class="compare-channnel-row">
                          <span>渠 道:</span>
                          <span>{{ channelCompareData.end_channelstr }}</span>
                        </div>
                        <div class="compare-channnel-row">
                          <span>撞单后名单状态:</span>
                          <span>{{
                            channelCompareData.end_tracestatus_name
                          }}</span>
                        </div>
                        <div class="compare-channnel-row">
                          <span>撞单后负责人:</span>
                          <span>{{
                            channelCompareData.end_marketer_str || "--"
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 表格区域 -->
                <div class="pl20 pr20 pb20">
                  <div class="collision-content-title flex items-center">
                    <span class="mr20">撞单手机号涉及名单</span>
                    <!-- <div class="flex items-center channel-compare">
                      <span class="channel-compare-title">
                        名单在当前校区时有权限直接定位至名单所在位置，无权限时点击姓名查看名单详情
                      </span>
                    </div> -->
                  </div>
                  <div
                    class="table-list"
                    style="position: relative"
                    ref="auto_height_table"
                  >
                    <TableList
                      :tableData="tableList"
                      @handleColumnChange="handleColumnChange"
                    >
                      <template v-slot:diy-slot="{ scope }">
                        <template
                          v-if="
                            scope.column.property == 'client_intention_level'
                          "
                        >
                          <i
                            v-for="n in Number(
                              scope.row.client_intention_level
                            )"
                            :key="n"
                            class="icon-heart-off"
                          ></i>
                        </template>
                      </template>
                      <el-table-column
                        ref="fixedColumn"
                        label="操作"
                        align="center"
                        width="150px"
                        fixed="right"
                      >
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            size="small"
                            @click.native.prevent="onClickView(scope.row)"
                          >
                            查看
                          </el-button>
                        </template>
                      </el-table-column>
                    </TableList>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <SliderBox
      :showSliderBox="showSliderBoxSee"
      class="user-seeing-slider"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :isTrack="isTrack"
        :ClassMessage="ClassMessage"
        :newclientTags="newclientTags"
        seeSliderTitle="查看名单"
        :customerId="customerId"
        :isAddTagVisible="false"
        :isHome="true"
        :activeName="activeName"
        :isRoot="isRoot"
        :iscanEdit="iscanEdit"
        @hideUserSliderBox="() => (showSliderBoxSee = false)"
        showAddTrack="true"
      ></userSeeing>
    </SliderBox>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
import TableList from "@/components/tables/switchTableCont.vue";
import channelRecordRequest from "../channelRecord.js";
import SliderBox from "@/components/SliderBox";
import userSeeing from "@/components/User/seeing.vue";

export default {
  name: "CustoMersmanage-custoMersmanage",

  data() {
    return {
      sliderWidth: "800px",
      showSliderBoxSee: false,
      customerId: "",
      ClassMessage: {},
      iscanEdit: false,
      isRoot: false,
      isTrack: false,
      isFilter: false,
      activeName: "first",
      newclientTags: [],

      channelCompareData: null,
      // 图片相关
      url: [],
      showImgUrlArr: [],
      showImgMask: false,
      showImgUrl: "",

      // 菜单和权限
      openMenu: ["3"],

      // 表格相关
      oprateColumn: [1, 4], // 编辑列
      showColumn: [],
      data: [],
      loading: false,
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], // 表格宽度
      tableData: [],
      optionscaozuo: {
        tableHeight: "auto",
      },
      columns: [],

      tableList: {
        list: [],
        columns: [],
        options: {
          mutiSelect: false,
          tableHeight: "auto", //表格高度
          errortip: "",
          issetting: false,
        },
      },

      // 详情查看相关
      rowData: null,
      showDetailPop: false,
      applyActive: "first",
      channelChangeList: [],
      channelChangeApplyNum: 0,

      minSliderwidth: "620px",
    };
  },

  components: {
    TableList,
    PageNav,
    SliderBox,
    userSeeing,
  },

  updated() {},

  created() {
    this.getClientConflictsMobileRepeat();
    this.getClientConflictsOne();
  },

  mounted() {},

  methods: {
    handleColumnChange(index, column, row) {
      this.onClickView(row);
    },
    onClickView(row) {
      // if (row.school_id == this.$Tool.getStorage("school_id")) {
      this.customerId = row.client_id;
      this.newclientTags = row.client_tag;
      this.activityId = row.activity_id;
      this.activeOne = row;
      this.showSliderBoxSee = true;
      // } else {
      //   this.$message.error("暂无权限");
      // }
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    getClientConflictsOne() {
      channelRecordRequest
        .getClientConflictsOne({
          conflicts_id: this.$route.query.conflicts_id,
        })
        .then((res) => {
          console.warn(res);
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.channelCompareData = data.list;
          } else {
            this.channelCompareData = null;
          }
        });
    },
    getClientConflictsMobileRepeat() {
      channelRecordRequest
        .getClientConflictsMobileRepeat({
          conflicts_id: this.$route.query.conflicts_id,
        })
        .then((res) => {
          const { code, data, msg } = res.data;
          data.field.forEach((v) => {
            if (v.fieldname == "client_intention_level") {
              v.diyCotnent = 1;
            }
            if (v.fieldname == "client_cnname") {
              v.ismethod = 1;
            }
          });
          this.tableList.columns = data.field;
          if (code === 200) {
            this.tableList.list = data.list;
            this.tableList.options.errortip = msg;
          } else {
            this.tableList.list = [];
            this.tableList.options.errortip = msg;
          }
        });
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../channelRecord.less");

.channelRecord {
  height: 100vh;
  font-size: 20px;

  // 渠道申请相关样式
  .apply-channel__desc {
    display: flex;
    margin: 0 -20px;
    line-height: 35px;
    align-items: center;
    justify-content: center;
    color: rgba(32, 168, 216, 1);
    background-color: rgba(32, 168, 216, 0.14);
  }

  .apply-channel__notice {
    color: red;
  }
  // 用户信息弹窗样式
  .apply-user-pop {
    display: flex;
    padding: 20px;
    align-items: center;

    .user-info__img {
      width: 100px;
      padding-right: 13px;
      display: flex;
      justify-content: flex-end;

      img {
        display: block;
        width: 53px;
        height: 53px;
        border-radius: 50%;
      }
    }

    .user-info__name {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      display: flex;
      align-items: center;

      .user-tips {
        margin-left: 20px;
        padding: 0 8px;
        font-size: 14px;
        line-height: 30px;
        font-style: normal;
        color: rgba(32, 168, 216, 1);
        border-radius: 5px;
        background-color: rgba(32, 168, 216, 0.05);
      }
    }
  }
  // 选择用户行样式
  .choose-user-row {
    display: flex;
    padding: 0 20px;

    .tit {
      width: 100px;
    }

    .user-content {
      flex: 1;
      padding-top: 2px;
      margin-bottom: 0px;
      display: flex;
      flex-wrap: wrap;
    }

    .user-content-item {
      margin: 0 30px 15px 0;
      position: relative;

      .el-icon-circle-close {
        top: -5px;
        right: -15px;
        position: absolute;
        color: red;
        cursor: pointer;

        &:hover {
          color: #20a8d8;
        }
      }
    }
  }

  // 侧边栏渠道记录样式
  .slider-channel-record {
    .user-header {
      display: flex;
      padding-top: 20px;
      align-items: flex-start;
      position: relative;
      .user-header__desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        .desc {
          display: flex;
          margin-bottom: 5px;
          align-items: center;
        }
        .desc-sex__img {
          margin: 0 15px 0 5px;
        }
        .tag-normal {
          padding: 0 5px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #20a8d8;
          line-height: 26px;
          border: 1px solid #20a8d8;
          border-radius: 3px;
        }
        .tag-status {
          padding: 0 6px;
          line-height: 26px;
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
        }
        .tag-red {
          background: #f35c5c;
        }
        .tag-blue {
          background: #20a8d8;
        }
        .tag-yellow {
          background: #f8cd09;
        }
      }
      .notice-tags {
        right: 20px;
        top: 20px;
        width: 98px;
        height: 98px;
        position: absolute;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          transform: rotate(-15deg);
          position: relative;
        }
        &.notice-success {
          color: #20a8d8;
          border: 1px solid #20a8d8;
        }
        &.notice-fail {
          color: #f35c5c;
          border: 1px solid #f35c5c;
        }
      }
      .user-header__img {
        margin-right: 10px;
      }
      td {
        width: 200px;
        line-height: 30px;
      }
    }

    .channel-apply-info {
      li {
        margin-bottom: 15px;
        font-size: 14px;
      }
      .tit {
        color: #aaa;
      }
      .desc {
        color: #666;
      }
    }
  }

  // 渠道视图标签页样式
  .channel-view__tabs {
    .el-tabs__nav {
      padding-left: 0;
    }
  }
  .slider-channel-record {
    .el-row .grid-content-img img {
      height: 100%;
    }
    .slider-studentBind .el-row .el-col {
      min-height: 178px;
    }
    .el-row .grid-content > p {
      height: auto;
    }
    .el-row .grid-content .communite-cont {
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      p {
        flex: 1;
      }
      .btns {
        width: 135px;
        margin-left: 10px;
        .el-button {
          width: 60px;
        }
        .btn-disabled {
          background-color: #cccccc;
          border-color: #cccccc;
        }
      }
    }
    .el-row .grid-content .communite-replay {
      display: flex;
      border-top: 1px dashed #ddd;
      .replay-cont {
        flex: 1;
        line-height: 24px;
      }
      .img {
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .replay-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  // 渠道历史记录样式
  .channel-history {
    margin: 0 0 0 10px;
    padding-bottom: 10px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 10px;
      width: 1px;
      height: 100%;
      background-color: rgba(40, 171, 217, 1);
      border-radius: 50%;
    }
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      margin-bottom: 20px;
    }
    .channel-history__title {
      margin: 0 0 10px 0;
      padding-left: 15px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a4a4a4;
      line-height: 20px;
      letter-spacing: 1px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: -5px;
        top: 5px;
        width: 6px;
        height: 6px;
        padding: 2px;
        border: 1px solid rgba(0, 173, 223, 1);
        background-color: rgba(0, 173, 223, 1);
        background-clip: content-box;
        border-radius: 50%;
      }
    }
    .channel-history-box {
      width: 96%;
      margin: 0 auto;
      padding: 20px 30px;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);
      .channel-row {
        display: flex;
        align-items: flex-start;
        .channel-detail {
          display: flex;
          flex: 5;
          padding: 16px 0;
          align-items: center;
          justify-content: space-around;
          background-color: rgba(32, 168, 216, 0.05);
          .channel-detail__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #3a3a3a;
            line-height: 19px;
            letter-spacing: 1px;
            p {
              margin-top: 20px;
              &:first-child {
                margin-top: 0;
              }
            }
          }
          .channel-detail__tips {
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 47px;
              height: 25px;
            }
            p {
              font-size: 12px;
              font-family: MicrosoftYaHei;
              color: #aaaaaa;
              line-height: 16px;
              letter-spacing: 1px;
            }
          }
        }
        .channel-status {
          flex: 2;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .dot {
            width: 6px;
            height: 6px;
            margin-right: 5px;
            border-radius: 50%;
          }
          &.status-success {
            color: rgba(32, 168, 216, 1);
            .dot {
              background-color: rgba(32, 168, 216, 1);
            }
          }
          &.status-fail {
            color: rgba(243, 92, 92, 1);
            .dot {
              background-color: rgba(243, 92, 92, 1);
            }
          }
          &.status-wait {
            color: rgba(6, 217, 3, 1);
            .dot {
              background-color: rgba(6, 217, 3, 1);
            }
          }
          &.status-warn {
            color: rgba(255, 203, 0, 1);
            .dot {
              background-color: rgba(255, 203, 0, 1);
            }
          }
        }
      }
    }
    .channel-history__teacher {
      margin-top: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #55606e;
      line-height: 19px;
      letter-spacing: 1px;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
  // 标签页数字提示样式
  .tab-num-tips {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -8px;
    font-size: 13px;
    color: #fff;
    line-height: 100%;
    font-style: normal;
    text-align: center;
    line-height: 16px;
    vertical-align: top;
    background-color: red;
    border-radius: 50%;
  }
}
</style>

<style lang="less" scoped>
.collision-content {
  margin-top: 28px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 20px 24px;
  font-size: 14px;
  background: linear-gradient(#ffffff 0%, #f2fbff 100%);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #e2f0f6;

  .collision-content-box {
    .p {
      margin-right: 90px;
      margin-bottom: 26px;
    }
    .content-title {
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;
    }
    .content-row {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
    }
  }
}
.collision-content-title {
  margin-bottom: 20px;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  position: relative;

  &::before {
    content: "";
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: rgba(123, 197, 228, 1);
    position: absolute;
  }
}
.channel-compare {
  font-size: 12px;
  border: 1px solid rgba(255, 154, 3, 1);
  border-radius: 4px;
  overflow: hidden;
  .channel-compare-title {
    padding: 5px 10px;
    color: rgba(255, 154, 3, 1);
    background-color: rgba(255, 244, 227, 1);
  }
  .channel-compare-content {
    padding: 5px 10px;
    color: #fff;
    background-color: rgba(255, 154, 3, 1);
  }
}

.compare-channnel-left,
.compare-channnel-right {
  max-width: 528px;
  min-width: 450px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2f0f6;

  .compare-channel-row__title {
    text-align: center;
    line-height: 52px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .compare-channnel-row {
    padding: 14px 24px 0 24px;
  }

  .compare-channnel-row {
    display: flex;
    font-size: 13px;
    align-items: center;
    span {
      &:first-child {
        width: 120px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
      }
      &:last-child {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
}

.compare-channel-arrow {
  width: 18px;
  height: 18px;
  margin: 0 15px;
  color: #fff;
  font-size: 12px;
  background-color: rgba(184, 231, 255, 1);
  border-radius: 50%;
  text-align: center;
  line-height: 14px;
}

.content-row-status {
  text-align: center;
  font-size: 13px;
  &.content-row-status-success {
    color: rgba(82, 196, 26, 1) !important;
    border: 1px solid rgba(82, 196, 26, 1);
    background-color: #f0f9eb;
    border-radius: 5px;
    padding: 3px 6px;
  }
  &.content-row-status-fail {
    color: #ff0000 !important;
    border: 1px solid #ff0000;
    background-color: #fff0f0;
    border-radius: 5px;
    padding: 3px 6px;
  }
}
</style>
